import { CheckboxEntry as CBE } from '@bpmn-io/properties-panel';
import type { FunctionalComponent, VNode } from '@bpmn-io/properties-panel/preact';
import type { Element } from 'bpmn-js/lib/model/Types';

export const CheckboxEntry = CBE as <E extends Element = Element>(props: {
    description?: string;
    disabled?: boolean;
    element: E;
    getValue: (element: E) => boolean;
    id: string;
    label?: string;
    onBlur?: (event: FocusEvent) => void;
    onFocus?: (event: FocusEvent) => void;
    setValue: (value: boolean, validationError?: unknown) => void;
    tooltip?: string | FunctionalComponent;
}) => VNode;

// isCheckboxEntryEdited